var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidebar-right",
    {
      class: [
        "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--600",
        { open: _vm.show },
      ],
      on: { overlayClicked: _vm.outside },
    },
    [
      _c("div", { staticClass: "h-100 bg-white" }, [
        _c("div", { staticClass: "card border-0" }, [
          _c(
            "div",
            {
              staticClass:
                "card-header d-flex align-items-center chat-header-title yellow-class",
            },
            [
              _c("div", { staticClass: "col px-0" }, [
                _c("h4", { staticClass: "h3 mb-0" }, [_vm._v("Change Logs:")]),
              ]),
            ]
          ),
          _c("div", { staticClass: "card-body p-0" }, [
            _c(
              "div",
              {
                staticClass: "timeline timeline-one-side bg-white",
                attrs: {
                  "data-timeline-content": "axis",
                  "data-timeline-axis-style": "dashed",
                },
              },
              _vm._l(_vm.logs, function (p, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass:
                      "timeline-block bg-white p-3 border border-right-0 border-left-0 border-top-0 d-flex flex-row m-0 justify-contnent-center align-items-center",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("user-avatar", {
                          attrs: { data: { user: p.user }, disableEdit: true },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "timeline-content m-0 p-0 col-md-12" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex justify-content-between pt-1",
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-pill align-baseline badge-info",
                                },
                                [_vm._v(_vm._s(_vm.logType(p)))]
                              ),
                            ]),
                            _c("div", { staticClass: "text-right" }, [
                              _c("small", { staticClass: "text-muted" }, [
                                _c("i", { staticClass: "fas fa-clock mr-1" }),
                                _vm._v(_vm._s(_vm.fromNow(p))),
                              ]),
                            ]),
                          ]
                        ),
                        _c("h6", { staticClass: "text-sm mt-2 mb-0 ml-1" }, [
                          _vm._v(_vm._s(p.subject)),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }